// extracted by mini-css-extract-plugin
export var archiveLabel = "ArchiveLabel-module--archiveLabel--50ad7";
export var text = "ArchiveLabel-module--text--3808a";